import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs, doc, getDoc, addDoc, updateDoc } from 'firebase/firestore';
import Footer from '../Components/footer';
import Navbar from '../Components/NavBarAirbnbStyle';
import './reservasRealizadas.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/free-solid-svg-icons';
import Trofeo from '../img/logoprueba.png';
import { db, auth } from '../Firebase/Firebase';
import Rating from 'react-rating-stars-component'; // Asegúrate de tener esta librería
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';
import QRCodeGenerator from '../Components/QRcodeGenerator';
const ReservasRealizadas = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState(''); // Estado para el término de búsqueda
  const [reservations, setReservations] = useState([]);
  const [spaces, setSpaces] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [calificacion, setCalificacion] = useState(0);
  const [comentario, setComentario] = useState('');
  const [selectedReservationId, setSelectedReservationId] = useState(null);
  const [qrCodeModalIsOpen, setQrCodeModalIsOpen] = useState(false);
  const [user,setUser]=useState(null);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed;
      }
    } catch (error) {
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;
    return prefersDark || isNight;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;
      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  useEffect(() => {
    const fetchReservations = async () => {
      onAuthStateChanged(auth, async (user) => {
        if (!user) return;

        try {
          const reservationsQuery = query(
            collection(db, 'reservas'),
            where('idUser', '==', user.uid)
          );

          const querySnapshot = await getDocs(reservationsQuery);
          const fetchedReservations = [];
          const fetchedSpaces = {};

          for (const snapshotDoc of querySnapshot.docs) {
            const reserva = snapshotDoc.data();
            const reservaId = snapshotDoc.id;

            // Obtener datos del cliente
            let fullName = 'Usuario desconocido';
            if (reserva.idUser) {
              const userDoc = await getDoc(doc(db, 'usuarios', reserva.idUser));
              if (userDoc.exists()) {
                const userData = userDoc.data();
                const name = userData.name || '';
                const lastname = userData.lastName || '';
                fullName = [name, lastname].filter(Boolean).join(' ') || fullName;
              }
            }
            reserva.userName = fullName;

            // Obtener datos del espacio
            const idEspacio = reserva.idEspacio || reserva.IdEspacio; // fallback
            if (idEspacio) {
              const espacioDoc = await getDoc(doc(db, 'espacios', idEspacio));
              if (espacioDoc.exists()) {
                const espacioData = espacioDoc.data();
                let tipoEspacioNombre = '';

                if (espacioData.TipoEspacio) {
                  const tipoEspacioDoc = await getDoc(doc(db, 'tipoespacio', espacioData.TipoEspacio));
                  if (tipoEspacioDoc.exists()) {
                    tipoEspacioNombre = tipoEspacioDoc.data().TipoEspacio || '';
                  }
                }

                fetchedSpaces[idEspacio] = {
                  imagen: espacioData.Imagenes?.[0] || 'defaultImage.jpg',
                  nombreEspacio: espacioData.NombreEspacio || 'Espacio',
                  tipoEspacio: tipoEspacioNombre,
                  logo: espacioData.logo || null,
                };
              }
            }

            fetchedReservations.push({
              ...reserva,
              id: reservaId,
              idEspacio: idEspacio,
            });
          }

          setReservations(fetchedReservations);
          setSpaces(fetchedSpaces);
        } catch (error) {
          console.error('Error al obtener las reservas:', error);
        }
      });
    };

    fetchReservations();
  }, []);

  const filteredReservations = reservations.filter((reserva) => {
    const espacio = spaces[reserva.idEspacio];
    return (
      espacio &&
      espacio.nombreEspacio &&
      espacio.nombreEspacio.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const nextReservation = () => {
    setCurrentIndex((prev) => (prev + 1) % filteredReservations.length);
  };

  const prevReservation = () => {
    setCurrentIndex((prev) => (prev - 1 + filteredReservations.length) % filteredReservations.length);
  };

  const handleReservationClick = (reservaId) => {
    setSelectedReservationId(reservaId);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setCalificacion(0);
    setComentario('');
  };

  const handleSaveCalificacion = async (reservaId) => {
    if (!reservaId || typeof reservaId !== 'string') {
      console.error('ID de reserva no es válido', reservaId);
      return;
    }

    try {
      const reservaDocRef = doc(db, 'reservas', reservaId);
      const reservaDoc = await getDoc(reservaDocRef);

      if (!reservaDoc.exists()) {
        console.error('No se encontró la reserva.');
        return;
      }

      const reservaData = reservaDoc.data();

      if (reservaData.reseñaRealizada) {
        toast.error('Ya se ha realizado una reseña para esta reserva.');
        return;
      }

      const { idEspacio, idUser } = reservaData;
      if (!idEspacio || !idUser) {
        console.error('Datos de reserva incompletos.');
        return;
      }

      await addDoc(collection(db, 'reseñas'), {
        idEspacio,
        Reseña: comentario,
        calificacion,
        userId: idUser,
      });

      await updateDoc(reservaDocRef, { reseñaRealizada: true });
      closeModal();
    } catch (e) {
      console.error('Error al guardar reseña o actualizar reserva:', e);
    }
  };


  return (
    <div className="resv-page">
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <ToastContainer />

      <div className="resv-presentation">
        <div className="resv-background">
          <h2 className="resv-title">RESERVAS REALIZADAS</h2>

          <input
            type="text"
            placeholder="Buscar espacio"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="resv-search"
          />

          {Array.isArray(filteredReservations) && filteredReservations.length > 0 ? (
            <div className="resv-card" key={filteredReservations[currentIndex]?.id || currentIndex}>

              <button className="resv-nav-btn prev" onClick={prevReservation}>❮</button>

              <div className="resv-grid">
                <div className="resv-column">
                  <img
                    className="resv-image"
                    src={spaces[filteredReservations[currentIndex]?.idEspacio]?.imagen || 'https://via.placeholder.com/150'}
                    alt="Espacio"
                  />

                  <div className="resv-info">
                    <h4>Tu espacio</h4>
                    <div className="resv-header">
                      <FontAwesomeIcon className="resv-icon" icon={faCrown} />
                      <p>{spaces[filteredReservations[currentIndex]?.idEspacio]?.nombreEspacio || 'Nombre de Espacio'}</p>
                    </div>
                    <div className="resv-user">
                      <h3>{filteredReservations[currentIndex]?.userName || 'Usuario'}</h3>
                      <img
                        className="resv-logo"
                        src={spaces?.[filteredReservations[currentIndex]?.idEspacio]?.logo || Trofeo}
                        alt="Logo"
                      />
                    </div>
                    <div className="resv-type">
                      <h3>Activado</h3>
                      <h4>{spaces[filteredReservations[currentIndex]?.idEspacio]?.tipoEspacio || 'Sala de reuniones'}</h4>
                    </div>
                  </div>
                </div>

                <div className="resv-column">
                  <p className="resv-section-title">DATOS DE LA RESERVA</p>
                  <div className="resv-detail">
                    <h4>Fecha</h4>
                    <p>{filteredReservations[currentIndex]?.fechaInicio || 'N/A'}</p>
                  </div>
                  <div className="resv-divider"></div>

                  <div className="resv-divider"></div>
                  <div className="resv-detail">
                    <h4>Hora/Inicio</h4>
                    <p>{filteredReservations[currentIndex]?.horaInicio || 'N/A'}</p>
                  </div>
                  <div className="resv-divider"></div>
                  <div className="resv-detail">
                    <h4>Hora/Final</h4>
                    <p>{filteredReservations[currentIndex]?.horaFinal || 'N/A'}</p>
                  </div>
                  <div className="resv-divider"></div>
                  <button className="resv-review-btn" onClick={() => qrCodeModalIsOpen(true)}>Descargar QR</button>
                  <button className="resv-review-btn" onClick={() => handleReservationClick(filteredReservations[currentIndex]?.id)}>Reseña</button>
                </div>
              </div>

              <button className="resv-nav-btn next" onClick={nextReservation}>❯</button>
            </div>
          ) : (
            <p>No hay reservas disponibles</p>
          )}
          {
            qrCodeModalIsOpen && (
              <QRCodeGenerator
                isOpen={qrCodeModalIsOpen}
                onClose={() => {
                  setQrCodeModalIsOpen(false);
                }}
                userName={`${user.name} ${user.lastname}`}
                espacio={''}
                reservationDate={filteredReservations[currentIndex]?.fechaInicio}
                startTime={filteredReservations[currentIndex]?.horaInicio}
                endTime={filteredReservations[currentIndex]?.horaFinal}
                reservaId={filteredReservations[currentIndex]?.id}  // NUEVO
                idUser={filteredReservations[currentIndex]?.idUser}   // NUEVO
                idEspacio={filteredReservations[currentIndex]?.idEspacio}
              />)
          }
        </div>
      </div>

      {showModal && (
        <div className="resv-modal">
          <h2>Realiza tu reseña del espacio</h2>
          <div className="resv-comment">
            <p>Calificación:</p>
            <Rating
              count={5}
              value={calificacion}
              onChange={setCalificacion}
              size={30}
              activeColor="#ffd700"
            />
            <p>Comentario:</p>
            <textarea
              className="resv-textarea"
              rows="4"
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </div>
          <div className="resv-modal-actions">
            <button className="resv-btn cancel" onClick={closeModal}>Cancelar</button>
            <button className="resv-btn save" onClick={() => handleSaveCalificacion(selectedReservationId)}>Guardar Reseña</button>
          </div>
        </div>
      )}
      <Footer />
    </div>

  );
};

export default ReservasRealizadas;